import { render } from "./create-menu.vue?vue&type=template&id=413d2474"
import script from "./create-menu.vue?vue&type=script&lang=js"
export * from "./create-menu.vue?vue&type=script&lang=js"

import "./create-menu.vue?vue&type=style&index=0&id=413d2474&lang=less"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__